import React,{useState,useEffect} from "react";
import {Table,DatePicker,Tooltip} from "antd";
import { useNavigate } from "react-router";
import back_img from "../../../assests/images/rightVector.svg";
import { serialNum } from "../../../utils";
import urls from "../../../api/urls";
import API from "../../../api";
// import not_attempted_icon  from "../../../assests/images/deliverAttemptLeftIcon.svg";
import attempted_icon from "../../../assests/images/notDeliveredIcon.svg";
import attempted_successfull_icon from "../../../assests/images/deliveryAttemptSuccessful.svg";
import { camelCase } from "../../../utils";
import "./style.scss";

const PendingDrs = () => {
  const [drsListResponse,setDrsListResponse]= useState([]);
  const [loading,setLoading]=useState(false);
  const { PENDING_DRS} = urls;
  const navigate = useNavigate();
  const { RangePicker } = DatePicker;
  const columns = [
    {
      title: "Sl No",
      align: "center",
      with: 10,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
    },
    {
      title: "In-scan date",
      dataIndex: "bookingTime",
      key: "bookingTime",
      render:(text)=>{
        return(
          <>
            <div>{text.split(" ")[0].split("-").reverse().join("-")}</div>
            <div>{text.split(" ")[1]}</div>
          </>
        );
      }
    },
    {
      title: "Booking CP Details",
      dataIndex: "",
      key: "",
      render:(text)=>{
        return(
          <>
            <div>{camelCase(text?.cpName)}</div>
            <div>{text?.cpNum}</div>
          </>
        );
      }
    },
    {
      title: "Receiver's Name",
      dataIndex: "addressDetails",
      key: "addressDetails",
      render:(text)=>{
        return(
          <>
            <div> <b>{text?.receiverName}</b> </div>
            <div>{text?.receiverAddressLine1}</div>
            <div>{text?.receiverAddressLine2}</div>
            <div>{text?.receiverMobileNumber}</div>
          </>
        );
      },
    },
    {
      title: "Delivery Attempts",
      dataIndex: "Delivery Attempt",
      key: "Delivery Attempt",
      render:()=>{
        return(
          <>
            <Tooltip title="Delivery failed">
              <img src={attempted_icon} style={{width:"16px",height:"16px",marginRight:"5px"}}/>
            </Tooltip>
            <Tooltip title="Delivery failed">
              <img src={attempted_icon} style={{width:"16px",height:"16px",marginRight:"5px"}}/>
            </Tooltip>
            <Tooltip title="Delivered">
              <img src={attempted_successfull_icon} style={{width:"16px",height:"16px",marginRight:"5px"}}/>
            </Tooltip>
            {/* <Tooltip title="zsdasdasd">
              <img src={not_attempted_icon} style={{width:"16px",height:"16px"}}/>
            </Tooltip> */}
          </>
        );
      }
    },
  ];
  useEffect(()=>{
    drsListFun();
  },[]);
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };
  let drsListFun = async()=>{ 
    setLoading(true);
    let response = await API.Api(PENDING_DRS).getWithPremiseIdHeader();
    if(response?.status){
      setDrsListResponse(response?.response?.data);
      setLoading(false);
    }
  };
  console.log(drsListResponse);
  return (
    <div className="m-2">
      <div className="heading align-center">
        <img
          src={back_img}
          onClick={() => navigate("/last-mile-operations")}
          style={{ cursor: "pointer" }}
        />
        <p
          style={{
            margin: "0",
            paddingLeft: "5px",
            fontWeight: "700",
            fontSize: "18px",
            lineHeight: "32px",
            letterSpacing: "-0.25px",
            color: "#061624",
          }}
        >
          <b>Pending for DRS</b>
        </p>
      </div>
      <div className="pending-drs-container mt-1">
        <div className="p-1" style={{display:"flex" , justifyContent:"end",alignItems:"center"}}>
          <RangePicker/>
        </div>
        <Table 
          loading={loading}
          columns={columns} 
          dataSource={drsListResponse}  
          pagination={{
            itemRender: itemRender,
          }}
        />
      </div>
    </div>
  );
};

export default PendingDrs;

